import React, { PropsWithChildren, useState } from 'react';

import { createHashRouter, createRoutesFromElements, Route, RouterProvider, useParams, Outlet, useNavigate, Navigate } from 'react-router-dom';

import './AdminContainer.css';

import { Dropdown } from 'react-bootstrap';
import { BefattningList } from './BefattningList';

export interface IAppProps {
    userId: number;
}

export interface IAdminContainerOutletContext {
    setShowFolderActionButton: (show: boolean) => void;
}

function AdminContainer(props: PropsWithChildren<IAppProps>) {
    const navigate = useNavigate();
    const [showFolderActionButton, setShowFolderActionButton] = useState(true);

    return (
        <div className="row">
            <div className="col-sm-12">

                <Outlet context={{ showFolderActionButton, setShowFolderActionButton }} />

            </div>

        </div>
    );
}

function AdminDefault(props: {}) {
    return <Navigate to="users" />;
}

function AdminContainerWithRouter(props: IAppProps) {
    const router = createHashRouter(
        createRoutesFromElements(
            <>
                <Route
                    path="/"
                    // element={<FilesContextProvider><FilesContainer userId={props.userId} /></FilesContextProvider>}>
                    element={<AdminContainer userId={props.userId} />}>

                    <Route path="/" element={<><AdminDefault /></>}>
                    </Route>,

                    <Route path="/users"
                        element={<><BefattningList /></>}
                    >

                    </Route>,
                    {/* <Route
                        element={<><AttachedFilePermissionForm /></>}
                        path="/:fileId/permissions"
                    /> */}
                </Route>
            </>
        ), {
        // basename:"/Data/Klient/Filer.aspx"
    });

    return (
        <RouterProvider router={router} />
    );
}

export default AdminContainerWithRouter;
